import React, { Component } from "react";

class Salary extends Component {
  constructor(props) {
    super(props);
    console.log("Salary Constructor");
  }
  state = {
    errorMessage: "",
    salaryJson: [],
    title: "",
    isSalaryView: false,
  };
  componentDidMount() {
    this.props.getSalaryYear();
    //this.props.getSalaryMonth();
  }

  toggleSalaryView = () => {
    this.setState({ isSalaryView: !this.state.isSalaryView });
  };
  handleYear = (e) => {
    let yearSelected = e.target.value;
    if (yearSelected > 0) {
      this.props.getSalaryMonth(yearSelected);
    }
  };
  render() {
    if (this.state.isSalaryView === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            {this.state.salaryJson !== null &&
            this.state.salaryJson.length > 0 ? (
              <div className="Array p-0 mb-5">
                <div className="w-100 text-center">
                  <img
                    className="img-128"
                    src={this.state.salaryJson[0].EmployerLogo}
                    alt={this.state.salaryJson[0].EmployerName}
                  ></img>
                </div>
                <p className="wp-header text-center">
                  {this.state.salaryJson[0].Title}
                </p>
                <div className="row">
                  <div className="col-6">
                    <span>
                      کدپرسنلی: <strong>{this.state.salaryJson[0].Code}</strong>
                    </span>
                  </div>
                  <div className="col-6">
                    <span>
                      کدملی:{" "}
                      <strong>{this.state.salaryJson[0].National_Code}</strong>
                    </span>
                  </div>
                  <div className="col-6">
                    <span>
                      نام: <strong>{this.state.salaryJson[0].F_Name}</strong>
                    </span>
                  </div>
                  <div className="col-6">
                    <span>
                      نام خانوادگی:{" "}
                      <strong>{this.state.salaryJson[0].L_Name}</strong>
                    </span>
                  </div>
                  <div className="col-12">
                    <span>
                      شماره حساب:{" "}
                      <span className="d-inline-flex font-weight-bold">
                        {this.state.salaryJson[0].AccountNo}
                      </span>
                    </span>
                  </div>
                  <div className="col-12">
                    <span>
                      سمت: <strong>{this.state.salaryJson[0].Semat}</strong>
                    </span>
                  </div>
                  <div className="col-12">
                    <span>
                      واحد:{" "}
                      <strong>{this.state.salaryJson[0].TaminPlace}</strong>
                    </span>
                  </div>
                </div>
                <hr></hr>
                <p className="wp-header bg-light text-dark small text-center">
                  اطلاعات کارکرد
                </p>
                {this.state.salaryJson[0].data.map((e) =>
                  e.CategoryCode === 4 ? (
                    <div className="row">
                      <div className="col-6">
                        <span>{e.CompensationTitle} :</span>
                      </div>
                      <div className="col-3 text-left">
                        <strong>{e.Value}</strong>
                      </div>
                      <div className="col-3 text-right">
                        <span>{e.MeasurementUnitTitle}</span>
                      </div>
                    </div>
                  ) : null
                )}
                <p className="wp-header bg-light text-dark small text-center">
                  حقوق و مزایا و فوق‌العاده‌ها
                </p>
                {this.state.salaryJson[0].data.map((e) =>
                  e.CategoryCode === 1 ? (
                    <div className="row">
                      <div className="col-6">
                        <span>{e.CompensationTitle} :</span>
                      </div>
                      <div className="col-3 text-left">
                        <strong>{e.Value}</strong>
                      </div>
                      <div className="col-3 text-right">
                        <span>{e.MeasurementUnitTitle}</span>
                      </div>
                    </div>
                  ) : null
                )}
                <div className="bg-info text-white p-1 mt-2">
                  {this.state.salaryJson[0].data.map((e) =>
                    e.CompensationName === "BonusSum" ? (
                      <span>
                        جمع حقوق و مزایا: <strong>{e.Value}</strong>{" "}
                        {e.MeasurementUnitTitle}
                      </span>
                    ) : null
                  )}
                </div>
                <p className="wp-header bg-light text-dark small text-center">
                  کسورات حقوق
                </p>
                {this.state.salaryJson[0].data.map((e) =>
                  e.CategoryCode === 2 ? (
                    <div className="row">
                      <div className="col-6">
                        <span>{e.CompensationTitle} :</span>
                      </div>
                      <div className="col-3 text-left">
                        <strong>{e.Value}</strong>
                      </div>
                      <div className="col-3 text-right">
                        <span>{e.MeasurementUnitTitle}</span>
                      </div>
                    </div>
                  ) : null
                )}
                <div className="bg-info text-white p-1 mt-2">
                  {this.state.salaryJson[0].data.map((e) =>
                    e.CompensationName === "DeductSum" ? (
                      <span>
                        جمع کسورات: <strong>{e.Value}</strong>{" "}
                        {e.MeasurementUnitTitle}
                      </span>
                    ) : null
                  )}
                </div>
                <div className="bg-success text-white p-1 mt-2">
                  {this.state.salaryJson[0].data.map((e) =>
                    e.CompensationName === "Payable" ||
                    e.CompensationName === "NetPay" ? (
                      <span>
                        خالص پرداختی: <strong>{e.Value}</strong>{" "}
                        {e.MeasurementUnitTitle}
                      </span>
                    ) : null
                  )}
                </div>
              </div>
            ) : (
              <div className="Array p-0 mb-5">
                <p className="wp-header small">فیش حقوقی</p>
                <div className="alert alert-warning">
                  <span>فیش حقوقی برای نمایش وجود ندارد.</span>
                </div>
              </div>
            )}
            <button
              onClick={this.toggleSalaryView}
              className="btn btn-danger wp-button-add"
            >
              <span>بازگشت</span>
            </button>
          </div>
        </React.Fragment>
      );
    } else {
      const year = this.props.yearJson.map((myList) => (
        <option key={myList.ID} value={myList.ID}>
          {myList.Title}
        </option>
      ));
      const Month = this.props.monthJson.map((myList) => (
        <option key={myList.ID} value={myList.ID}>
          {myList.Title}
        </option>
      ));
      return (
        <React.Fragment>
          <div className="container-fluid">
            <div className="item body-padding">
              <p className="wp-header">انتخاب فیش حقوقی</p>
              <div className="row">
                <div className="col-6">
                  <label className="wp-text-sm">سال</label>
                  <select
                    id="YearOfSalary"
                    name="YearOfSalary"
                    className="form-select text-left"
                    onChange={this.handleYear}
                  >
                    <option value="">انتخاب سال</option>
                    {year}
                  </select>
                </div>
                <div className="col-6">
                  <label className="wp-text-sm">ماه</label>
                  <select
                    id="MonthOfSalary"
                    name="MonthOfSalary"
                    className="form-select text-left"
                  >
                    <option value="">انتخاب ماه</option>
                    {Month}
                  </select>
                </div>
              </div>
              <button
                onClick={this.getSalaryPayCalc}
                className="btn btn-success wp-button-add"
              >
                <span>مشاهده</span>
              </button>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  getSalaryPayCalc = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var yearOfSalaryValue = document.getElementById("YearOfSalary").value;
      if (yearOfSalaryValue === null || yearOfSalaryValue === "") {
        const errorMessage = "سال مورد نیاز را انتخاب کنید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        var monthOfSalaryValue = document.getElementById("MonthOfSalary").value;
        if (monthOfSalaryValue === null || monthOfSalaryValue === "") {
          const errorMessage = "ماه مورد نیاز را انتخاب کنید.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("Year", yearOfSalaryValue);
        formdata.append("Month", monthOfSalaryValue);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_API_URL}/api/user/get-user-salary`,
          requestOptions
        )
          .then((response) => response.text())
          .then((result) => {
            if (result !== null) {
              // this.toggleBlocking();
              var myObject = JSON.parse(result);
              if (myObject.status === 0) {
                this.setState({ salaryJson: myObject.data }, function() {
                  console.log(this.state.salaryJson);
                  this.toggleSalaryView();
                });
              } else {
                const errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
              }
            }
          })
          .catch((error) => console.log("error", error));
      }
    } else {
      const errorMessage = "عدم مجوز برای دریافت اطلاعات.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default Salary;
